import http from './http'

export const PRIORITIES = ['HIGH', 'MEDIUM', 'LOW']
export const STATUSES = ['PENDING', 'IN_PROGRESS', 'PAUSED', 'COMPLETED']
export const TASK_TYPES = ['NEW', 'BUG', 'OPTIMIZE']

export function fetchMySidebarTasks() {
  return http.get('/tasks/sidebar')
}

export function fetchCalendarTasks(params) {
  return http.get('/tasks/calendar', { params })
}

export function fetchTask(id) {
  return http.get(`/tasks/${id}`)
}

export function createTask(payload) {
  return http.post('/tasks', payload)
}

export function updateTask(id, payload) {
  return http.put(`/tasks/${id}`, payload)
}

export function changeTaskStatus(id, status) {
  return http.patch(`/tasks/${id}/status`, { status })
}

export function appendTaskDates(id, dates) {
  return http.post(`/tasks/${id}/dates`, { dates })
}

export function removeTaskDate(id, date) {
  return http.delete(`/tasks/${id}/dates/${date}`)
}

export function clearTaskDates(id) {
  return http.delete(`/tasks/${id}/dates`)
}

export function batchAppendDates(payload) {
  return http.post('/tasks/batch-dates', payload)
}

export function softDeleteTask(id) {
  return http.delete(`/tasks/${id}`)
}

export function reassignTask(id, executorUserId) {
  return http.patch(`/tasks/${id}/reassign`, { executorUserId })
}

export function createSupplement(taskId, payload) {
  return http.post(`/tasks/${taskId}/supplements`, payload)
}

export function fetchTasksByExecutor(userId, params) {
  return http.get(`/tasks/by-executor/${userId}`, { params })
}

export function fetchTasksByDepartment(deptId, params) {
  return http.get(`/tasks/by-department/${deptId}`, { params })
}

export function fetchTasksByProject(projectId, params) {
  return http.get(`/tasks/by-project/${projectId}`, { params })
}

export function fetchAssignedUserIds() {
  return http.get('/tasks/assignable-users')
}